import React from 'react';
import { TICKET_STATUS_FILTER } from 'constants/ticketStatuses';
import { formatDate, makeDisplayName } from '../../../../util/formatUtil';
import { validCommunicationType } from '../../../../constants/conversationTypes';
import { determineTicketDisplayName, getChannelIconSrc, determineTicketSubject } from '../../../../util';
import { isAnswered as isTicketAnswered } from '../../../../selectors/tickets';
import ExpiryTimer from '../../ExpiryTimer/ExpiryTimer';
import { getExpiryTimeForTicket, showTicketExpiryTimer } from 'util/timerUtil';
import { isLiveChat } from 'util/chat';
import { isTicketReviewTicket } from 'util/ticketSelector';
import {
  TicketWrapper,
  MessageContainer,
  IconContainer,
  MessageTextContainer,
  MessageTextLeft,
  MessageTextRight,
  TicketText,
  MessageTextOverflow,
  SmallText,
  StatusTextWrapper,
  UpsellTooltipContent,
  UpsellTooltipTitle,
  UpsellTooltipDescription,
} from '../Queue.styles';
import DOMPurify from 'dompurify';
import UpsellIcon from 'components/common/UpsellIcon/UpsellIcon';
import { ToolTip } from 'components/common/tooltips';

const TicketItem = (props) => {
  const { ticket, inboxTab, isAdmin, allFilter, onShowMessageDetails, idsToExperts, isAPartnerProtector } = props;

  const conversationUpdatedAt = formatDate(ticket.conversationUpdatedAt);

  let statusContent = '';
  if (isAdmin && inboxTab === 'all' && allFilter === TICKET_STATUS_FILTER.all) {
    // display ticket status
    statusContent = ticket.ticketStatus.replace(/_/g, ' ');
    const expert = idsToExperts[ticket.expertId];
    if (expert) {
      // display expert name
      const displayName = makeDisplayName({
        id: expert.id,
        firstName: expert.firstName,
        lastName: expert.lastName,
      });
      statusContent += ` - ${displayName}`;
    }
  } else {
    if (isTicketAnswered(ticket)) {
      statusContent = 'Awaiting Reply';
    } else {
      if (isLiveChat(ticket.communicationType)) {
        statusContent = 'New Chat';
      } else {
        statusContent = 'New Email';
      }
    }
  }

  const isUpsellTicket = !!ticket.moreTicketInfo?.humanAndBotBothActiveInChat;

  // determines proper email/name to display
  const displayName = determineTicketDisplayName(ticket, isAdmin, false);
  let subject = determineTicketSubject(ticket);
  subject = DOMPurify.sanitize(subject);

  const isSelected = props.selectedNonHistoricalTicketId === ticket.ticketId;
  const isAnswered = isTicketAnswered(ticket);
  const { simplrTicketNumber } = ticket;

  return (
    <TicketWrapper
      tabIndex={props.tabIndex}
      data-focus-index={props['data-focus-index']}
      data-focus-skip={props['data-focus-skip']}
      onFocus={() => {
        if (!isSelected) {
          onShowMessageDetails(ticket.ticketId, inboxTab);
        }
      }}
      key={ticket.ticketId}
    >
      <MessageContainer
        onClick={() => {
          onShowMessageDetails(ticket.ticketId, inboxTab);
        }}
        selected={isSelected}
      >
        <IconContainer resize={ticket.communicationType === validCommunicationType.TWITTER_DM}>
          <img alt="" src={getChannelIconSrc(ticket, isTicketReviewTicket(ticket, isAPartnerProtector), isSelected)} />
        </IconContainer>
        <MessageTextContainer>
          <MessageTextLeft>
            {displayName ? (
              <TicketText selected={isSelected} isAnswered={isAnswered}>
                {simplrTicketNumber}&nbsp; &rarr; &nbsp;{displayName}
              </TicketText>
            ) : (
              <TicketText selected={isSelected} isAnswered={isAnswered}>
                {simplrTicketNumber}
              </TicketText>
            )}
            <MessageTextOverflow selected={isSelected} isAnswered={isAnswered}>
              {subject}
            </MessageTextOverflow>
            {showTicketExpiryTimer(ticket, isAdmin) && (
              <ExpiryTimer loadingBar {...ticket} ticketExpiresIn={getExpiryTimeForTicket(ticket)} />
            )}
          </MessageTextLeft>
          <MessageTextRight>
            <StatusTextWrapper>
              {isUpsellTicket && (
                <ToolTip
                  arrow
                  theme="light"
                  placement="top"
                  content={
                    <UpsellTooltipContent>
                      <UpsellTooltipTitle>Upsell Asurion Home+</UpsellTooltipTitle>
                      <UpsellTooltipDescription>
                        Upsell Asurion Home+ to the customer and receive a bonus!
                      </UpsellTooltipDescription>
                    </UpsellTooltipContent>
                  }
                >
                  <div>
                    <UpsellIcon />
                  </div>
                </ToolTip>
              )}
              <SmallText $selected={isSelected} isAnswered={isAnswered}>
                {statusContent}
              </SmallText>
            </StatusTextWrapper>
            <SmallText $selected={isSelected} isAnswered={isAnswered}>
              {conversationUpdatedAt}
            </SmallText>
          </MessageTextRight>
        </MessageTextContainer>
      </MessageContainer>
    </TicketWrapper>
  );
};

export default TicketItem;
